<div *ngIf="adminMode || contentSection.title" class="title-container flex align-center">
	<h2 *ngIf="contentSection.title" class="title">{{contentSection.title | getLocale:contentSection?.locale?.title}}</h2>
	<div class="right flex align-center">
		<!-- Admin controls hidden in preview mode -->
		<ng-container *ngIf="adminMode && !isPreviewMode">
			<span class="mr-3">{{ contentSection.name }}</span>

			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="openDialog.emit({ contentSection: contentSection, order: undefined })">
					<mat-icon>edit</mat-icon>
					Edit
				</button>
				<button mat-menu-item (click)="delete.emit(contentSection)">
					<mat-icon>delete</mat-icon>
					Delete
				</button>
				<button mat-menu-item (click)="moveUp.emit(contentSection)">
					<mat-icon>arrow_upward</mat-icon>
					Move Up
				</button>
				<button mat-menu-item (click)="moveDown.emit(contentSection)">
					<mat-icon>arrow_downward</mat-icon>
					Move Down
				</button>
			</mat-menu>

			<button mat-icon-button [matMenuTriggerFor]="menu">
				<mat-icon>more_vert</mat-icon>
			</button>
		</ng-container>
	</div>
</div>

<h3 *ngIf="contentSection.subtitle" class="subtitle">{{contentSection.subtitle | getLocale:contentSection?.locale?.subtitle}}</h3>

<div #bodyElement *ngIf="body" class="body mb-4" [innerHtml]="body | safeHtml: contentSection?.sanitizeHtml" (click)="handleContainerClick($event)"></div>

<!-- Template Grid -->
<app-creative-unit-package-listing-container
	*ngIf="contentSection.templates?.enabled"
	[filters]="{ ids: contentSection.templates?.ids, categories: contentSection.templates?.categories, tags: contentSection.templates?.tags}"
	[layout]="contentSection.templates?.layout"
	[thumbnailStyle]="contentSection.templates?.thumbnailStyle"
	[searchbar]="contentSection?.searchbar"
	[paginator]="contentSection?.paginator"
	[useTemplates]="contentSection.useTemplates"
	[businessIds]="contentSection.filterByProjectBusiness && projectsQuery.getActive()?.business?.id ? [projectsQuery.getActive().business.id] : undefined"
	[locale]="contentSection?.locale"
	[preloadedListings]="preloadedListings"
	(selectedListing)="selectedListing.emit($event)"
	(selectedPartialListing)="selectedPartialListing.emit($event)"
></app-creative-unit-package-listing-container>
